(() => {
  window.__WT_COLLECTION_HOVER = true;

  const SLIDE_DELAY_MS = 1000;
  const INITIAL_PRELOAD_CONCURRENCY = 3;
  const GALLERY_PRELOAD_CONCURRENCY = 2;
  const preloadCache = new Map();
  let initialPreloadScheduled = false;

  function log(...args) {
    // toggle si tu veux
    // console.log(...args);
  }

  function stop(card) {
    if (card && card.__wt_timer) {
      clearTimeout(card.__wt_timer);
      card.__wt_timer = null;
    }
    if (card) card.__wt_sequence = (card.__wt_sequence || 0) + 1;
  }

  function findPrimaryImg(root) {
    // Dawn: .card__media .media img (le premier est le "main", le deuxième est souvent "secondary")
    const media = root.querySelector(".card__media .media");
    if (media) {
      const imgs = media.querySelectorAll("img");
      if (imgs && imgs.length) return imgs[0];
    }
    // fallback
    return root.querySelector(".card__media img") || root.querySelector("img");
  }

  function preloadImage(url, priority = "low") {
    if (!url) return Promise.resolve(false);

    const cached = preloadCache.get(url);
    if (cached) {
      if (priority === "high" && "fetchPriority" in cached.image) {
        cached.image.fetchPriority = "high";
      }
      return cached.promise;
    }

    const image = new Image();
    image.decoding = "async";
    if ("fetchPriority" in image) image.fetchPriority = priority;

    let settled = false;
    const promise = new Promise((resolve) => {
      const finish = async (success) => {
        if (settled) return;
        settled = true;

        if (success && typeof image.decode === "function") {
          try { await image.decode(); } catch (error) { /* onload remains authoritative */ }
        }

        if (!success) preloadCache.delete(url);
        resolve(success);
      };

      image.addEventListener("load", () => finish(true), { once: true });
      image.addEventListener("error", () => finish(false), { once: true });
      image.src = url;

      if (image.complete && image.naturalWidth > 0) finish(true);
    });

    preloadCache.set(url, { image, promise });
    return promise;
  }

  async function applyImage(img, url, priority = "high") {
    if (!img || !url) return false;

    const ready = await preloadImage(url, priority);
    if (!ready) return false;

    // The decoded image is already in the browser cache before the visible swap.
    img.setAttribute("src", url);
    img.setAttribute("srcset", url);
    img.removeAttribute("sizes");
    return true;
  }

  async function preloadQueue(urls, concurrency) {
    const uniqueUrls = [...new Set(urls.filter(Boolean))];
    let cursor = 0;

    const workers = Array.from(
      { length: Math.min(concurrency, uniqueUrls.length) },
      async () => {
        while (cursor < uniqueUrls.length) {
          const url = uniqueUrls[cursor++];
          await preloadImage(url, "low");
        }
      }
    );

    await Promise.all(workers);
  }

  function runWhenIdle(callback, timeout = 1500) {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(callback, { timeout });
    } else {
      window.setTimeout(callback, 150);
    }
  }

  function parseGallery(btn) {
    const raw = btn.getAttribute("data-gallery") || "[]";
    try {
      const arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch (e) {
      console.warn("[WT] data-gallery invalid JSON", raw);
      return [];
    }
  }

  function setActiveDot(dots, active) {
    dots.forEach((d) => d.removeAttribute("data-active"));
    if (active) active.setAttribute("data-active", "true");
  }

  function attachDotHandlers(card) {
    const img = findPrimaryImg(card);
    const mediaArea = card.querySelector(".card__media");
    const mediaLink = card.querySelector("[data-variant-link]");
    const productLinks = Array.from(card.querySelectorAll(".card__heading a"));
    const dotsWrap = card.querySelector(".card-color-dots");
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll(".card-color-dot")) : [];
    const defaultVariantUrl = mediaLink?.getAttribute("href") || productLinks[0]?.getAttribute("href") || "";

    if (!card.dataset.wtActiveVariantUrl) {
      card.dataset.wtActiveVariantUrl = defaultVariantUrl;
    }

    // Navigation universelle (desktop + mobile) pour les SVG et les images.
    // La destination est lue au moment du clic afin de suivre le variant actif.
    if (mediaArea && card.dataset.wtMediaNavInit !== "1") {
      card.dataset.wtMediaNavInit = "1";

      card.addEventListener("click", (event) => {
        if (event.target.closest(".card-color-dot")) return;

        const rect = mediaArea.getBoundingClientRect();
        const isInsideMedia =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;

        if (!isInsideMedia) return;

        const destination = card.dataset.wtActiveVariantUrl || defaultVariantUrl;
        if (!destination) return;

        event.preventDefault();
        event.stopPropagation();
        window.location.assign(destination);
      }, true);
    }

    if (!img || dots.length === 0) return;

    // prevent double init
    if (card.dataset.wtHoverInit === "1") return;
    card.dataset.wtHoverInit = "1";

    // save original (une seule fois)
    const orig = {
      src: img.getAttribute("src") || img.currentSrc || img.src,
      srcset: img.getAttribute("srcset") || "",
      sizes: img.getAttribute("sizes") || ""
    };

    img.dataset.wtOrigSrc = orig.src;
    img.dataset.wtOrigSrcset = orig.srcset;
    img.dataset.wtOrigSizes = orig.sizes;
    if (mediaLink) mediaLink.dataset.wtOrigHref = mediaLink.getAttribute("href") || "";
    productLinks.forEach((link) => {
      link.dataset.wtOrigHref = link.getAttribute("href") || "";
    });

    async function startFromDot(btn) {
      stop(card);
      const sequence = card.__wt_sequence;

      setActiveDot(dots, btn);

      const gallery = parseGallery(btn);
      const fallback = btn.getAttribute("data-variant-image") || "";
      const variantUrl = btn.getAttribute("data-variant-url") || "";
      const urls = gallery.length ? gallery : (fallback ? [fallback] : []);

      if (variantUrl) card.dataset.wtActiveVariantUrl = variantUrl;
      if (mediaLink && variantUrl) mediaLink.setAttribute("href", variantUrl);
      if (variantUrl) {
        productLinks.forEach((link) => link.setAttribute("href", variantUrl));
      }

      if (!urls.length) return;

      let i = 0;
      const firstReady = await applyImage(img, urls[i], "high");
      if (!firstReady || sequence !== card.__wt_sequence) return;

      if (urls.length > 1) {
        // Prioritize the next frame, then warm the rest without blocking the page.
        preloadImage(urls[1], "high");
        runWhenIdle(() => preloadQueue(urls.slice(2), GALLERY_PRELOAD_CONCURRENCY));

        const scheduleNext = () => {
          card.__wt_timer = window.setTimeout(async () => {
            if (sequence !== card.__wt_sequence) return;

            const nextIndex = (i + 1) % urls.length;
            const nextReady = await applyImage(img, urls[nextIndex], "high");
            if (sequence !== card.__wt_sequence) return;

            if (nextReady) i = nextIndex;
            scheduleNext();
          }, SLIDE_DELAY_MS);
        };

        scheduleNext();
      }
    }

    function reset() {
      stop(card);
      setActiveDot(dots, null);

      const oSrc = img.dataset.wtOrigSrc || orig.src;
      img.setAttribute("src", oSrc);

      const oSrcset = img.dataset.wtOrigSrcset || orig.srcset;
      if (oSrcset) img.setAttribute("srcset", oSrcset);
      else img.removeAttribute("srcset");

      const oSizes = img.dataset.wtOrigSizes || orig.sizes;
      if (oSizes) img.setAttribute("sizes", oSizes);
      else img.removeAttribute("sizes");

      if (mediaLink && mediaLink.dataset.wtOrigHref) {
        mediaLink.setAttribute("href", mediaLink.dataset.wtOrigHref);
      }
      card.dataset.wtActiveVariantUrl = defaultVariantUrl;
      productLinks.forEach((link) => {
        if (link.dataset.wtOrigHref) link.setAttribute("href", link.dataset.wtOrigHref);
      });
    }

    // Desktop hover (pointer events = mieux que mouseenter)
    dots.forEach((btn) => {
      btn.addEventListener("pointerenter", () => startFromDot(btn));
      // Mobile/touch: on click aussi
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        startFromDot(btn);
      });
    });

    // Desktop seulement : restaurer l'aperçu en quittant la carte avec une souris.
    // Sur iPhone, Safari émet aussi pointerleave après un toucher; il ne faut pas
    // réinitialiser le variant choisi dans ce cas.
    card.addEventListener("pointerleave", (event) => {
      if (event.pointerType === "mouse") reset();
    });

    // Sécurité : si Shopify remplace l'image, on garde l'orig à jour au besoin
    // (optionnel, mais safe)
    const obs = new MutationObserver(() => {
      // si l'image n'a pas d'orig, on le remet
      if (!img.dataset.wtOrigSrc) {
        img.dataset.wtOrigSrc = img.getAttribute("src") || img.currentSrc || img.src;
        img.dataset.wtOrigSrcset = img.getAttribute("srcset") || "";
        img.dataset.wtOrigSizes = img.getAttribute("sizes") || "";
      }
    });
    obs.observe(card, { subtree: true, childList: true, attributes: true });
  }

  function boot() {
    const cards = document.querySelectorAll(".card-wrapper");
    cards.forEach(attachDotHandlers);

    if (!initialPreloadScheduled && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      initialPreloadScheduled = true;

      const firstFrameUrls = Array.from(document.querySelectorAll(".card-color-dot"))
        .map((dot) => {
          const gallery = parseGallery(dot);
          return gallery[0] || dot.getAttribute("data-variant-image") || "";
        })
        .filter(Boolean);

      // Cards sit below the fold, so this starts shortly after critical page assets.
      window.setTimeout(() => {
        runWhenIdle(
          () => preloadQueue(firstFrameUrls, INITIAL_PRELOAD_CONCURRENCY),
          1000
        );
      }, 120);
    }

    log("[WT] collection hover boot — cards:", cards.length, "dots:", document.querySelectorAll(".card-color-dot").length);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
